export default function() {
    const form = document.getElementById('careers-form-register');
    if (!form) {
        return;
    }

    const validator = new ContactFormValidator({
        element: form
    });

    form.addEventListener('submit', async function(e) {
        e.preventDefault();
        if (!await validator.isValid()) {
            return false;
        }

        const formData = new FormData(form);
        validator.preventInput();

        $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            dataType: 'json',
            url: form.getAttribute('action'),
            data: formData,
            success: function(response) {
                validator.allowInput();

                var div = $('<div class="careers-thankyou"></div>');

                div.append('<h1>Thank you</h1>');
                div.append('<p>Thanks for registering your interest with Stellantis &You UK.  We’ll keep you updated with new opportunities.</p><p>Kind regards<br/>Stellantis &You UK Recruitment Team</p>');

                $('#careers-form-register').html(div);
                $('.careers-modal')[0].scrollIntoView();

                dataLayer.push({
                    'event' : 'trackEvent',
                    'eventCategory' : 'Careers - Register Interest',
                    'eventAction' : 'Form Complete',
                    'eventLabel' : 'Complete',
                    'eventValue' : 0,
                });
            },
            error: function(response) {
                validator.errorResponse(response);
            }
        });
    });
}